import * as actions from "../constants/actionTypes";

const initialState = {
    underwriter: null,
    client: null,
    vessel: null,
};

export default function selected(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.SELECTED_UNDERWRITER:
            newState.underwriter = action.payload;
            break;
        case actions.UNSELECTED_UNDERWRITER:
            newState.underwriter = null;
            break;

        case actions.SELECTED_CLIENT:
            newState.client = action.payload;
            break;
        case actions.UNSELECTED_CLIENT:
            newState.client = null;
            break;

        case actions.SELECTED_VESSEL:
            newState.vessel = action.payload;
            break;
        case actions.UNSELECTED_VESSEL:
            newState.vessel = null;
            break;
        default: break;
    }
    return newState;
}


// WEBPACK FOOTER //
// ./src/reducers/selected.js